import "react-datepicker/dist/react-datepicker.css";
import DashboardScreen from "./pages/DashboardScreen";
import "./index.css";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function CoderCompanion() {
  const navigate = useNavigate();
  const permissions = JSON.parse(sessionStorage.getItem("permissions")) || {};

  useEffect(() => {
    if (permissions.admin) return;

    const hasDiscoveryPermission =
      permissions?.DiscoveryCompanion || permissions?.["Code Enhance"];

    if (!hasDiscoveryPermission) {
      navigate("/no-access");
    }
  }, [permissions, navigate]);

  return <DashboardScreen />;
}

export default CoderCompanion;